import React, { Component, Dispatch } from 'react';
import { ICourseList } from '../../models/pages/coursePage';
import { Common } from '../../core/common';
import { withRouter } from 'react-router-dom';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import moment from 'moment';
import Paginate from '../../components/table/paginate';
import { IPagedQuery, IPagedQueryS } from '../../models/components/paginate';
import * as ActionsCoursePage from '../../store/actions/coursePage';
import { threadId } from 'worker_threads';
import { connect } from 'react-redux';
import { IAction, IAppState } from '../../models/action/core';

let _common: Common;

const _logger = Log.create('ClassList');

const T = Translator.create();

export class CClassList extends Component<ICourseList, any> {

    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state ={
            filters: {
                take: 3,
                page: 1,
                total:0
            },
        }

    }

    getClasses = async (paging: IPagedQueryS) => {
        this.props.dispatch(ActionsCoursePage.getCourseClassesData(
            this.props.userMyClasses!.results![0].courseId!,
            paging,
            'getCourseClassesData', 
            'get'
        ));
    };

    onPageChange = async (page: number) => {
        this.state.filters.page = page;
        this.setState(this.state);
        await this.getClasses(this.state.filters)
        this.state.filters.page = 1;
    };

    public navigateUrl(classId?: string | null, activityId?: string | null) {
        const url = 'course?classId=' + classId + '&activityId=' + activityId + '&type=1';
        this.props.history.push(url);
    }

    public findStartDate(courseId: string){
        if (this.props.userHomeMyCourses && this.props.userHomeMyCourses!.length > 0) {
            const courseClass = this.props.userHomeMyCourses!.find(x => x.courseId === courseId);
            if (courseClass) {
                const index = this.props.userHomeMyCourses!.indexOf(courseClass);
                return moment(this.props.userHomeMyCourses![index].startDate).isValid() ? moment(this.props.userHomeMyCourses![index].startDate).format("DD-MM-YYYY") : '-';
            }else return ''
        }else return ''
    }

    public findEndDate(courseId: string){
        if (this.props.userHomeMyCourses && this.props.userHomeMyCourses!.length > 0) {
            const courseClass = this.props.userHomeMyCourses!.find(x => x.courseId === courseId);
            if (courseClass) {
                const index = this.props.userHomeMyCourses!.indexOf(courseClass);
                return moment(this.props.userHomeMyCourses![index].endDate).isValid() ? moment(this.props.userHomeMyCourses![index].endDate).format("DD-MM-YYYY") : '-';
            }else return ''
        }else return ''
    }

    public render() {
        return (
            <div className="card card-body p-0 pb-2 myClasses">
                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead>
                            <tr className="class_table_head">
                                <th scope="col">{T.t('r_gen_class_name')}</th>
                                <th scope="col">{T.t('r_gen_filter_course_parameter_program')}</th>
                                <th scope="col">{T.t('r_gen_start_date')}</th>
                                <th scope="col">{T.t('r_gen_end_date')}</th>
                            </tr>
                        </thead>
                        <tbody className="class_table_body">
                        {this.props.userMyClasses!.results && this.props.userMyClasses!.results.length > 0 ? 
                        ( this.props.userMyClasses!.results!.map((item: any, index: any) =>
                            <tr key={index}>
                                <th scope="row"><a href=''  onClick={this.navigateUrl.bind(this, item.classId, item.courseId)}>
                                    {item.className}
                                    </a>
                                </th>
                                <td>{item.programName}</td>
                                <td>{item.startDate ? item.startDate.format("DD-MM-YYYY") : this.findStartDate(item.courseId)}</td>
                                <td>{item.startDate ? item.startDate.format("DD-MM-YYYY") : this.findEndDate(item.courseId)}</td>
                            </tr>)): ''}
                        </tbody>
                    </table>
                    <div className="page-sorting d-flex align-items-center justify-content-center">
                        <Paginate
                            class={'custom-paginate'}
                            filters={this.props.userMyClasses!.filters!}
                            onPageChange={this.onPageChange}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ICourseList): ICourseList => {
    if (!state) {
        return ownProps;
    }
    const newProps: ICourseList = Object.assign({}, ownProps, {
        userHomeMyCourses: state.userHomePage.userHomeMyCourses,
        useHomeMyCoursesIsLoading: state.userHomePage.useHomeMyCoursesIsLoading,
        userType: state.login.identitiy.userType,
        userMyClasses: state.coursePage.userMyClasses
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        // next.userHomePage.useHomeMyCoursesIsLoading === prev.userHomePage.useHomeMyCoursesIsLoading
        next.userHomePage.userHomeMyCourses === prev.userHomePage.userHomeMyCourses &&
        next.coursePage.userMyClasses === prev.coursePage.userMyClasses 
    );
    return ret;
};
const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};


const ClassList = connect(
    mapStateToProps,
    dispatchProps,
    null, {
    areStatesEqual
}
)(CClassList);

export default ClassList;
